<template>
  <nx-fullscreen-dialog
    :active="active"
    :title="$t(`message.block.form.video.title`)"
    @dismiss="dismiss"
  >
    <template slot="toolbar-items">
      <v-btn
        :disabled="!isValid"
        @click="insertBlot"
        color="accent"
        flat
        v-html="$t('message.block.form.video.accept')"
      ></v-btn>
    </template>
    <v-container pb-3 fluid>
      <v-flex class="md8 offset-md2 sm10 offset-sm1 pt-4">
        <v-layout row wrap>
          <v-flex class="xs12 order-xs1 order-sm2">
            <nx-content-selector
              :allow-non-published="allowNonPublished"
              :label="$t('message.block.form.video.search')"
              :type="['video', 'videoembed']"
              :value="video"
              @input="updateVideo"
            ></nx-content-selector>
            <v-text-field :label="$t('message.block.form.video.title')" v-model="data.title"></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
  </nx-fullscreen-dialog>
</template>
<script>
import ContentSelector from '@/modules/content/selector/Selector';
import api from '@/modules/content/search/api';
import Video from '../blots/videoEmbed';

import DialogButton from './DialogButton';

export default {
  name: 'nx-video-button',
  extends: DialogButton,
  components: {
    [ContentSelector.name]: ContentSelector,
  },
  props: {
    embedAuthor: String,
    embedTitle: String,
    embedId: String,
    embedThumbnail: String,
    embedType: String,
    allowNonPublished: Boolean,
  },
  data() {
    return {
      name: 'videoEmbed',
      video: null,
      data: {
        author: null,
        title: null,
        id: null,
        thumbnail: null,
        type: null,
      },
    };
  },
  methods: {
    updateVideo(video) {
      this.video = video;
      this.data.id = video.id;
      this.data.title = video ? video.title : '';
      this.data.thumbnail = video ? video.thumbnailUrl : '';
      this.data.type = video ? video.type : 'video';
    },
    async fetchVideo() {
      this.video = await api.getContent({ type: this.data.type, id: this.data.id });
    },
  },
  computed: {
    isValid() {
      return Boolean(this.video);
    },
  },
  mounted() {
    this.data = {
      author: this.embedAuthor || '',
      title: this.embedTitle || '',
      id: this.embedId || '',
      thumbnail: this.embedThumbnail || '',
      type: this.embedType || '',
    };

    if (this.embedId) {
      this.fetchVideo();
    }
  },
};
</script>
